module.exports = __webpack_public_path__ + "static/banner-mobile-7ed052e2cd17690d0a26b0a12ae66da9.png";